import { request } from 'utils/api/request'

const googleRedirect = () => {
  return request({ path: '/google/auth', method: 'GET' })
}

export { googleRedirect }
